export const COLLECTION = {
  GAMES: "games/",
  POLLS: "polls/"
};
